import { render, staticRenderFns } from "./NewDashboard.vue?vue&type=template&id=6d38610c&scoped=true"
import script from "./NewDashboard.vue?vue&type=script&lang=js"
export * from "./NewDashboard.vue?vue&type=script&lang=js"
import style0 from "./NewDashboard.vue?vue&type=style&index=0&id=6d38610c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d38610c",
  null
  
)

export default component.exports